import React, { useContext } from "react";
import ResponsiveLogoTitle from "../components/ResponsiveLogoTitle";
import { store } from "../store";

const ThankYou: React.FunctionComponent = () => {
    const globalState = useContext(store);
    const { dispatch } = globalState;

  return (
      <div className="text-center">
        <ResponsiveLogoTitle />
        <h1>Thank you for using the Workers Comp Inquiry Portal.</h1>
        <h3 className="color-green" >
            You will receive an email regarding your submission.
        </h3>
        <h4>
            <a className="color-green" href="/">Back to Home</a>
        </h4>
    </div>
    );
  };

export default ThankYou;
